import * as pkg from '../package.json';
export var authTrackOverride = {
    software: {
        name: pkg.name,
        version: pkg.version,
    },
};
//# sourceMappingURL=track.js.map